import React, { useState, useEffect,useRef } from "react";
import { Link } from "react-router-dom";
import EmployeeListFilter from "../../../components/EmployeeListFilter";
import Breadcrumbs from "../../../components/Breadcrumbs";
import AllEmployeeAddPopup from "../../../components/modelpopup/AllEmployeeAddPopup";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import SearchBox from "../../../components/SearchBox";
import { Avatar_02,Avatar_01 } from "../../../Routes/ImagePath";
import { Table } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { format } from "date-fns";

const dateFormat =  "MMM dd, yyyy";
//localStorage.getItem("dateFormat") ||

const EmployeeList = () => {
  const [employeeData, setEmployeeData] = useState([]);
  const [filteredEmployeeData, setFilteredEmployeeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingFilteredData, setLoadingFilteredData] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem('token');
  const cdnUrl = process.env.REACT_APP_CDN_URL;
  const [isFullScreen, setFullScreen] = useState(false);
  const maximizeBtnRef = useRef(null);


  const capitalizeFirstChar = (string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  

  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        setFullScreen(true);
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          setFullScreen(false);
        }
      }
    };

    const cleanup = () => {
      if (isFullScreen && document.exitFullscreen) {
        document.exitFullscreen();
        setFullScreen(false);
      }
    };

    const maximizeBtn = maximizeBtnRef.current;
    maximizeBtn.addEventListener('click', handleClick);

    return () => {
      maximizeBtn.removeEventListener('click', handleClick);
      cleanup();
    };
  }, [isFullScreen]);


  useEffect(() => {
    fetchEmployeeData();
  }, [apiUrl, token]);

  const fetchEmployeeData = () => {
    setLoading(true);
    setLoadingFilteredData(true);
    fetch(`${apiUrl}/employees/list`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => response.json())
      .then((data) => {
        setEmployeeData(data.employees);
        setFilteredEmployeeData(data.employees);
        setLoading(false);
        setLoadingFilteredData(false);
      })
      .catch((error) => {
        console.error("Error fetching employee data:", error);
        setLoading(false);
        setLoadingFilteredData(false);
      });
  };

  const handleEmployeeAdded = (newEmployee) => {
    setEmployeeData([...employeeData, newEmployee]);
    setFilteredEmployeeData([...filteredEmployeeData, newEmployee]); // Update filtered employee data as well, if needed
  };

  const handleFilterApplied = (filteredData) => {
    setFilteredEmployeeData(filteredData);
  };

  const updateEmployeeStatus = async (employeeId, currentStatus) => {

    const statusOptions = [
      { value: "1", label: "Active" },
      { value: "2", label: "Probation" },
      { value: "3", label: "Inactive" },
      { value: "4", label: "Resigned" },
      { value: "5", label: "Relieved" },
      { value: "6", label: "Terminated" }
    ];
  
    const currentStatusIndex = statusOptions.findIndex((option) => option.value === currentStatus);
  
    if (currentStatusIndex === -1) {
      console.error('Invalid currentStatus:', currentStatus);
      return;
    }
  
    let newStatusIndex = (currentStatusIndex + 0) % statusOptions.length;

    // Find the next status option that is different from the current one
    while (statusOptions[newStatusIndex].value === currentStatus) {
      newStatusIndex = (newStatusIndex + 1) % statusOptions.length;
    }

    newStatusIndex = (newStatusIndex - 1); 

    // Extract the new status value
    const newStatusValue = statusOptions[newStatusIndex].value;

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to change the status to ${statusOptions[newStatusIndex].label}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, change it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
    });
  
  
    if (result.isConfirmed) {
      try {
        await axios.put(
          `${apiUrl}/employees/updateemployee/?isempstatus=1`,
          { id: employeeId, empstatus: newStatusValue },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );
  
        // Update the employee data with the new status
        setEmployeeData(
          employeeData.map((employee) =>
            employee.id === employeeId ? { ...employee, empstatus: newStatusValue } : employee
          )
        );
  
        // Update the filtered employee data with the new status
        setFilteredEmployeeData(
          filteredEmployeeData.map((employee) =>
            employee.id === employeeId ? { ...employee, empstatus: newStatusValue } : employee
          )
        );
  
        await Swal.fire('Updated!', 'Employee status has been updated.', 'success');
      } catch (error) {
        let errorMessage = 'Failed to update employee status. Please try again later.';
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        }
        await Swal.fire('Error!', errorMessage, 'error');
      }
    }
  };
  
  

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <span className="table-avatar">
          <Link to={`/profile/${record.id}`} className="avatar">
            <img 
  src={record.profile_pic 
        ? `${cdnUrl}/${record.profile_pic}` 
        : (record.gender === 'male' ? Avatar_01 : Avatar_02)
       }
  alt="Employee Avatar"
/>


          </Link>
          <Link to={`/profile/${record.id}`}>
            {text} <span>{record.lastname}</span>
          </Link>
        </span>
      ),
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Employee ID",
      dataIndex: "empcode",
      key: "employee_id",
      sorter: (a, b) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      render: (text) => capitalizeFirstChar(text) || "-", // Capitalize gender text for rendering
      sorter: (a, b) => capitalizeFirstChar(a.gender).localeCompare(capitalizeFirstChar(b.gender)), // Apply capitalization to both values
    },
    {
      title: "Martial Status",
      dataIndex: "martial_status",
      key: "martial_status",
      render: (text) => capitalizeFirstChar(text) || "-", // Capitalize gender text for rendering
      sorter: (a, b) => capitalizeFirstChar(a.martial_status).localeCompare(capitalizeFirstChar(b.martial_status)), // Apply capitalization to both values

    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      render: (text) => text || "-",
      sorter: (a, b) => a.mobile.localeCompare(b.mobile),
    },
    {
      
      title: "Join Date",
      dataIndex: "employee_doj",
      key: "joindate",
      render: (text) => text ? format(new Date(text), dateFormat) : "-",
      sorter: (a, b) => a.joindate.localeCompare(b.employee_doj),
    },
    {
      title: "Role",
      dataIndex: "designation_name",
      key: "role",
      render: (text) => text || "-",
      sorter: (a, b) => a.role.localeCompare(b.designation_name),
    },
    {
      title: "Department",
      dataIndex: "department_name",
      key: "role",
      render: (text) => text || "-",
      sorter: (a, b) => a.role.localeCompare(b.department_name),
    },
    {
      title: "Social Security No",
      dataIndex: "social_security_numbe",
      key: "social_security_numbe",
      render: (text) => text || "-",
      sorter: (a, b) => a.role.localeCompare(b.social_security_numbe),
    },
    {
      title: "PAN No",
      dataIndex: "pan_no",
      key: "pan_no",
      render: (text) => text || "-",
      sorter: (a, b) => a.role.localeCompare(b.pan_no),
    },
    {
      title: "Present Address",
      dataIndex: "present_address",
      key: "present_address",
      sorter: (a, b) => a.role.localeCompare(b.present_address),
    },
    {
      title: "Permanent Address",
      dataIndex: "permanent_address",
      key: "permanent_address",
      sorter: (a, b) => a.role.localeCompare(b.permanent_address),
    },
    {
      title: "Emergency Contact",
      dataIndex: "emergency_contact",
      key: "emergency_contacts",
      sorter: (a, b) => a.role.localeCompare(b.emergency_contact),
    },
    {
      title: "Emergency Contact Relation",
      dataIndex: "emergency_contact_relation",
      key: "emergency_contact_relation",
      sorter: (a, b) => a.role.localeCompare(b.emergency_contact_relation),
    },
    {
      title: "Emergency Contact Phone",
      dataIndex: "emergency_contact_phone",
      key: "emergency_contact_phone",
      sorter: (a, b) => a.role.localeCompare(b.emergency_contact_phone),
    },

    {
      title: "Status",
      dataIndex: "empstatus",
      key: "status_column",
      render: (text, record) => {
        const statusOptions = [
          { value: "1", label: "Active" },
          { value: "2", label: "Probation" },
          { value: "3", label: "Inactive" },
          { value: "4", label: "Resigned" },
          { value: "5", label: "Relieved" },
          { value: "6", label: "Terminated" }
        ];
    
        const currentStatus = statusOptions.find(option => option.value === text) || { value: "0", label: "Unknown" };
    
        console.log(`empstatus for record ${record.id}:`, text);
        console.log(`currentStatus for record ${record.id}:`, currentStatus);
    
        return (
          <div className="dropdown action-label">
            <Link
              className={`btn btn-white btn-sm btn-rounded dropdown-toggle ${currentStatus.value === "1" ? 'text-success' : 'text-danger'}`}
              to="#"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className={`far fa-dot-circle ${currentStatus.value === "1" ? 'text-success' : 'text-danger'}`} /> {currentStatus.label}
            </Link>
            <div className="dropdown-menu">
              {statusOptions.map(option => (
                option.value !== currentStatus.value && (
                  <Link
                    key={option.value}
                    className="dropdown-item"
                    to="#"
                    onClick={() => updateEmployeeStatus(record.id, option.value)}
                  >
                    <i className={`far fa-dot-circle ${option.value === "1" ? 'text-success' : 'text-danger'}`} /> {option.label}
                  </Link>
                )
              ))}
            </div>
          </div>
        );
      },
      sorter: (a, b) => a.empstatus.localeCompare(b.empstatus),
    }
    
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">


      <div className="page-header page-top-icons">
          <div className="row align-items-center">
            <div className="col-md-4">
            <h3 className="page-title">Employees</h3>
            </div>
            <div className="col-md-8 float-end ms-auto">
              <div className="d-flex title-head">
                <div className="view-icons">
                <Link to="/employees" className="grid-view btn btn-link">
                    <i className="fa fa-th" />
                  </Link>

                  <Link to="/employee-list" className="list-view btn btn-link active mx-2">
                    <i className="fa fa-bars" />
                  </Link>

                  <Link to="#" className="list-view btn btn-link" data-bs-toggle="modal"  data-bs-target="#scrollable-modal">
              <i className="las la-filter" />
            </Link>
                  
            <Link to="#" className="list-view btn btn-link" id="collapse-header" ref={maximizeBtnRef}>
                    <i className="las la-expand-arrows-alt" />
                  </Link>


                  <Link
                      to="#"
                      className="list-view btn btn-link"
                      data-bs-toggle="modal"
                      data-bs-target="#export"
                    >
                      <i className="las la-file-export" />
                      
                    </Link>


                    <Link
                      to="#"
                      className="list-view btn btn-link"
                      data-bs-toggle="modal"
                      data-bs-target="#import_employees"
                    >
                      <i className="las la-file-import" />
                      
                    </Link>
                </div>
                <Link to="#" className="btn add-btn custom-btn" data-bs-toggle="modal" data-bs-target="#add_employee">
                <i className="la la-plus-circle custom-icon" /> Add New
                </Link>
              </div>
            </div>
          </div>
        </div>

   


        <EmployeeListFilter
          onFilterApplied={handleFilterApplied}
          employeeData={employeeData}
          loading={loadingFilteredData}
        />
        <div className="row">
          <div className="col-md-12">
            {loading ? (
              <div id="loader-wrapper-">
                <div className="loader">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </div>
            ) : (
              <div className="table-responsive">
     
                                  <Table
                    className="table-striped"
                    columns={columns.map((col, index) => {
                      // Freeze the first 4 columns
                      if (index < 2) {
                        return { ...col, fixed: 'left' };
                      }
                      return col;
                    })}
                    dataSource={filteredEmployeeData}
                    rowKey={(record) => record.id}
                    scroll={{
                      x: 3500, // Set horizontal scroll width (adjust based on total table width)
                      y: 400,  // Optional: Set vertical scroll height
                    }}
                  />

              </div>
            )}
          </div>
        </div>
      </div>
      <AllEmployeeAddPopup onEmployeeAdded={handleEmployeeAdded} />
      <DeleteModal Name="Delete Employee" />
    </div>
  );
};

export default EmployeeList;
